import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { HttpService } from './http.service';

@Injectable({
  providedIn: 'root'
})
export class AuthService {

  constructor(
    private httpService: HttpService,
    private router: Router
  ) { }

  /**
   * ====================================================
   * Admin Authentication Methods
   *
   * Token Name - calplay-admin-token
   * User Details - calplay-admin-user
   * ====================================================
   * */

  adminLogin(payload: any) {
    return this.httpService.post('admin/login', payload);
  }

  adminLogout() {
    localStorage.removeItem('calplay-admin-token');
    localStorage.removeItem('calplay-admin-user');
    this.router.navigate(['/login'])
  }

  adminLoggedIn() {
    return !!localStorage.getItem('calplay-admin-token')
  }

  getAdminToken() {
    return localStorage.getItem('calplay-admin-token')
  }

  getAdminAccountDetails() {
    return this.httpService.post('admin/details', {});
  }

  /**
   * =====================================================
   * End of Admin Authentication Methods
   * =====================================================
   * */

  getToken() {
    if (this.getAdminToken()) {
      return localStorage.getItem('calplay-admin-token')
    } else {
      return null;
    }
  }
}
